import { apiRoutes } from '../config/api'
import type { VideoPreview, VideoPreviewRequestDto, VideoPreviewResponseDto } from '../models/videoPreview'
import { toVideoPreview } from '../models/videoPreview'
import { post } from './httpClient'

export async function getVideoPreview(url: string, signal?: AbortSignal): Promise<VideoPreview> {
  const response = await post<VideoPreviewRequestDto, VideoPreviewResponseDto>(
    apiRoutes.videoPreview,
    { url },
    signal,
  )

  return toVideoPreview(response)
}
